<div class="outbound-step-from-shortcut-search-content">
  <div class="details-container">
    <span class="details-title" style="--fileName: '{{fileNameSearchCriteria}}'"></span>
    <sg-text class="outbound-shortcut-description" color="text-secondary" variant="sg-p3-standard">
      Here are the files that were created and sent out from your file.
      <span style="font-weight: bold">Do you see what you were looking for below?</span>
    </sg-text>
  </div>
  <sg-inspector-files-table
    [columns]="outboundColumns"
    [tableData$]="outboundTableData$"
    [fileContent$]="outboundFileContent$"
    (onClickRow)="onClickRow.emit($event)"
    (onClickDownloadFile)="onClickDownloadFile.emit($event)">
    <div id="file-details-container" class="file-details-container">
      <sg-text variant="sg-p2" color="text-tertiary">
        Created from inbound file:
        <sg-text variant="sg-p2" color="text-primary">{{fileNameSearchCriteria}}</sg-text>
      </sg-text>
    </div>
  </sg-inspector-files-table>
  <div class="buttons-container">
    <div class="top-line-button">
      <sg-button
        (onClick)="clickNavigateButton('shortcutSearch')"
        class="ghost-button"
        size="medium"
        text="Refine search"
        icon="arrow_back"
        iconPosition="start"
        variant="ghost-secondary"></sg-button>
    </div>
    <div class="bottom-line-buttons">
      <sg-button (onClick)="onClickClose.emit()" size="medium" text="Yes! Close investigation" icon="sg_checkmark_circle" variant="secondary"></sg-button>
      <sg-button
        (onClick)="clickNavigateButton('expandedSearch')"
        size="medium"
        text="No... Go to extended search"
        icon="youtube_searched_for"
        variant="primary"></sg-button>
    </div>
  </div>
</div>
